<template>
    <v-select
        v-model="computedSelect"
        :items="getTopicLearningGoals"
        :no-data-text="$t('Keine Lernziele verfügbar')"
        :label="$t('Lernziele')"
        :hint="computedHint"
        persistent-hint
        return-object
        item-text="name"
    />
</template>

<script>
import CourseMixin from '../../Mixins/CourseMixin';

export default {
    name: 'learning-goal-selector',
    mixins: [CourseMixin],
    watch: {
        getTopicLearningGoals(value) {
            if (value.length == 0) {
                this.computedSelect = {};
                this.SET_SELECTED_LEARNING_GOAL({});
            }
        },
        getSelectedTopic(value) {
            if (Object.keys(value).length !== 0) {
                this.GET_TOPIC_LEARNING_GOALS(value).then(() => {
                    if (this.getTopicLearningGoals.length > 0) {
                        this.computedSelect = this.getTopicLearningGoals[0];
                    } else {
                        this.computedSelect = {};
                    }
                });
            } else {
                this.SET_LEARNING_GOALS([]);
            }
        }
    },
    computed: {
        computedHint() {
            if (this.computedSelect.hasOwnProperty('id')) {
                if (this.getTopicLearningGoals.map((goal) => goal.id).includes(this.computedSelect.id)) {
                    return `min: ${this.computedSelect.minScore}, max: ${this.computedSelect.score}`;
                }
            }
            return '';
        },
        computedSelect: {
            get() {
                return this.getSelectedLearningGoal;
            },
            set(value) {
                this.SET_SELECTED_LEARNING_GOAL(value);
            }
        }
    },
    mounted() {
        if (this.getTopicLearningGoals.length === 0) {
            if (Object.keys(this.getSelectedTopic).length !== 0) {
                this.GET_TOPIC_LEARNING_GOALS(this.getSelectedTopic).then(() => {
                    if (this.getTopicLearningGoals.length > 0) {
                        this.computedSelect = this.getTopicLearningGoals[0];
                    } else {
                        this.computedSelect = {};
                    }
                });
            }
        }
    }
};
</script>
